'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  transition: ', ';\n  height: ', ';\n  opacity: ', ';\n  transform: ', ';\n  overflow: hidden;\n'], ['\n  transition: ', ';\n  height: ', ';\n  opacity: ', ';\n  transform: ', ';\n  overflow: hidden;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../../core/Style');

var _TwoWayTransition = require('../../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccordionTransitionWrapper = (0, _styledComponents2.default)(function (props) {
  var __measuredHeight = props.measuredHeight,
      rest = _objectWithoutProperties(props, ['measuredHeight']);

  return _react2.default.createElement(_TwoWayTransition2.default.PlainWrapper, rest);
}).withConfig({
  displayName: 'AccordionTransition__AccordionTransitionWrapper'
})(_templateObject, function (_ref) {
  var duration = _ref.duration,
      measuredHeight = _ref.measuredHeight,
      transitioning = _ref.transitioning;
  return measuredHeight != null && transitioning && 'height ' + duration + 'ms cubic-bezier(0.25, 0.1, 0.25, 1),\n    opacity ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1),\n    transform ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1)';
}, function (_ref2) {
  var hidden = _ref2.hidden,
      measuredHeight = _ref2.measuredHeight,
      transitioning = _ref2.transitioning;
  return transitioning && (hidden ? 0 : measuredHeight + 'px');
}, function (_ref3) {
  var hidden = _ref3.hidden,
      transitioning = _ref3.transitioning;
  return transitioning && (hidden ? 0 : 1);
}, function (_ref4) {
  var hidden = _ref4.hidden,
      transitioning = _ref4.transitioning;
  return transitioning && (hidden ? 'translateY(' + (0, _Style.remCalc)(-10) + ')' : 'translateY(0)');
});

var AccordionTransition = function (_React$Component) {
  _inherits(AccordionTransition, _React$Component);

  function AccordionTransition(props) {
    _classCallCheck(this, AccordionTransition);

    var _this = _possibleConstructorReturn(this, (AccordionTransition.__proto__ || Object.getPrototypeOf(AccordionTransition)).call(this, props));

    _this.state = { measuredHeight: 0 }; // 0 = not needed, null = needed
    return _this;
  }

  _createClass(AccordionTransition, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.open !== nextProps.open) {
        this.setState({ measuredHeight: null });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.measuredHeight == null) {
        this.measureHeight();
      }
    }
  }, {
    key: 'measureHeight',
    value: function measureHeight() {
      if (this.props.children === null) return;
      var el = (0, _reactDom.findDOMNode)(this);
      if (!el) return;
      this.setState({ measuredHeight: el.scrollHeight });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          duration = _props.duration,
          open = _props.open,
          rest = _objectWithoutProperties(_props, ['children', 'duration', 'open']);

      return _react2.default.createElement(
        _TwoWayTransition2.default,
        _extends({}, rest, {
          duration: duration,
          measuredHeight: this.state.measuredHeight
        }),
        open ? children : null
      );
    }
  }]);

  return AccordionTransition;
}(_react2.default.Component);

AccordionTransition.propTypes = {
  children: _react.PropTypes.node,
  duration: _react.PropTypes.number.isRequired,
  open: _react.PropTypes.bool.isRequired,
  Wrapper: _react.PropTypes.func.isRequired
};

AccordionTransition.defaultProps = {
  Wrapper: AccordionTransitionWrapper
};

exports.default = AccordionTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/accordion/internal/AccordionTransition.js
// module id = 434
// module chunks = 0